import { CommerceService } from "@/services/commerce"

/**
 * If triggered more than once (custom type exists, error will be returned)
 *
 * Kept here to track progress and for future migrations.
 * Purpose to add custom fields for customLineItem and then store product, sku and other information
 */
export const mutationAddCustomCustomLineItemType = {
  async addCustomCustomLineItemType(parent, args, context, info) {
    const commerceApi = CommerceService.api()

    const typeDraft = {
      key: "customCustomLineItemTypeKey",
      name: { "de-DE": "customCustomLineItemTypeName", "en-US": "customCustomLineItemTypeName" },
      description: {
        "de-DE": "Benutzerdefinierte Felder für benutzerdefinierte Werbebuchungen",
        "en-US": "Custom fields for custom line items",
      },
      resourceTypeIds: ["custom-line-item"],
      fieldDefinitions: [
        {
          type: {
            name: "String",
          },
          name: "productId",
          label: {
            "de-DE": "Product id",
            "en-US": "Product id",
          },
          required: false,
        },
        {
          type: {
            name: "String",
          },
          name: "sku",
          label: {
            "de-DE": "Sku",
            "en-US": "Sku",
          },
          required: false,
        },
        {
          type: {
            name: "String",
          },
          name: "priceId",
          label: {
            "de-DE": "Price id",
            "en-US": "Price id",
          },
          required: false,
        },
        {
          type: {
            name: "String",
          },
          name: "colorId",
          label: {
            "de-DE": "color id",
            "en-US": "color id",
          },
          required: false,
        },
      ],
    }

    try {
      await commerceApi.types().post({ body: typeDraft }).execute()

      return true
    } catch (error) {
      throw new Error(error)
    }
  },
}
